import React, { useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';
import Tooltip from 'components/Tooltip';
import { useMediaQuery } from 'hooks';
import breakpoints from 'utils/breakpoints';
import { showErrorMessage } from 'redux/slices/notification';

const CodeWithCopy = forwardRef(({ content, testId }, ref) => {
  const dispatch = useDispatch();
  const isMedium = useMediaQuery(breakpoints.md);
  const [text, setText] = useState('Copy');

  const onCopy = () => {
    try {
      navigator.clipboard.writeText(ref.current?.innerText);
      setText('Copied!');
      setTimeout(() => {
        setText('Copy');
      }, 1500);
    } catch (err) {
      dispatch(showErrorMessage('Could not copy to clipboard'));
    }
  };

  return (
    <div className="w-full code-block py-2 border border-javelin-inputBorder my-3 relative flex items-center justify-between">
      <span className="overflow-auto" ref={ref}>
        {content}
      </span>
      {isMedium && (
        <Tooltip
          text={text}
          className="relative"
          contentClass={`text-center -top-9 -left-10 w-fit-content p-1.5 ${
            text === 'Copy'
              ? 'text-brand-primary bg-white'
              : 'bg-brand-primary text-white'
          } select-none transition-opacity duration-200 ease-in-out`}
          Icon={CopyIcon}
          iconClassName="h-4 text-javelin-gray-light fill-current flex-shrink-0 hover:text-brand-primary cursor-pointer transition-all duration-200 ease-in-out"
          onClickIcon={onCopy}
          testId={testId}
        />
      )}
    </div>
  );
});

CodeWithCopy.propTypes = {
  content: PropTypes.string.isRequired,
  testId: PropTypes.string,
};
CodeWithCopy.defaultProps = {
  testId: 'copy',
};

export default CodeWithCopy;
